import React from 'react';
import Attributes from '../../../components/Attributes';
const CONTRACT_MODULE_ID = process.env.REACT_APP_MODULE_ID_CONTRACT;

const VendorStepContract = ({
	moduleFieldsBreakdown,
	skipModuleKeys,
	updatedForm,
	setUpdateForm,
	form,
}) => {
	return (
		<>
			{moduleFieldsBreakdown?.vendor
				?.filter((field) => skipModuleKeys.indexOf(field.key) === -1)
				?.map((field) => (
					<>
						<Attributes
							field={field}
							onChange={(index, value, fullValue) => {
								if (value || fullValue) {
									let updatedValue = form[index]?.value;

									if (fullValue) {
										updatedValue = fullValue;
									} else {
										if (updatedValue && Array.isArray(value)) {
											updatedValue = [
												...(Array.isArray(updatedValue)
													? updatedValue
													: [updatedValue]),
												...value,
											];
										} else {
											updatedValue = value;
										}
									}

									setUpdateForm({
										...updatedForm,
										[index]: {
											value: updatedValue,
											fieldId: field.id,
										},
									});
								} else {
									let updated = { ...updatedForm };
									updated[index] = {
										...updated[index],
										value: null,
									};

									setUpdateForm(updated);
								}
							}}
							form={{ ...form, ...updatedForm }}
							updatedForm={updatedForm}
							setForm={setUpdateForm}
							moduleId={CONTRACT_MODULE_ID}
						/>
					</>
				))}
		</>
	);
};

export default VendorStepContract;
